import { observer } from 'mobx-react-lite'
import { Table } from 'shared/ui/TableNew'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type ReviewRow } from 'entities/Review'
import { getExportReportAction } from 'widgets/ExportAnalyticsModal'
import { useReviewsListContext } from 'pages/reviews/context'
import { ReviewsRoutes } from 'pages/reviews/route/type'
import { columns } from 'pages/reviews/pages/all/ui/ReviewsListTable/columns'
import { getReviewActions } from 'pages/reviews/actions/getReviewActions'

export const ReviewsListTable = observer(() => {
  const entities = useEntitiesContext()
  const { items, tableStore, scrollToTopTrigger, onSuccessDelete, openExportModal } =
    useReviewsListContext()

  const rows: ReviewRow[] = items.map((item) => {
    item.setActionsProps({
      actions: getReviewActions({
        item,
        entities,
        onSuccessDelete: () => onSuccessDelete(item.id),
        exportAction: getExportReportAction({
          disabled: !item.happyCount && !item.unhappyCount,
          onExport: () => openExportModal(item.id),
        }),
      }),
      showItems: 0,
      noVisibleActions: true,
    })
    return item
  })

  return (
    <Table
      ariaLabel={'ReviewsList'}
      virtualization
      pinnedColumnIds={['name']}
      store={tableStore}
      columns={columns}
      rows={rows}
      getRowLink={(row) => `/${ReviewsRoutes.root}/${ReviewsRoutes.view}/${row.id}`}
      scrollToTOpTrigger={scrollToTopTrigger}
    />
  )
})
